import { gql } from "@apollo/client";

export const CREATE_STUDENT_APPLICANT = gql`
  mutation CreateStudentApplicant($input: CreateStudentApplicantInput) {
    createStudentApplicant(input: $input) {
      studentApplicantId
    }
  }
`;















